<script setup>
import {onBeforeMount, reactive, ref, nextTick} from "vue";
import createTenantBikeStore from "./components/createTenantBikeStore/index.vue";
import router from "@/router/index.js";
import {getBikeStoreIgnore, updateBikeStoreIgnore} from "@/api/bikeStore/ignoreTenant.js";
import moment from "moment";
/*获取路由信息，带参则为修改*/
import {getRoute} from "@/hooks/getRoute.js";
import {ElMessage} from "element-plus";
import YTAddress from "@/components/YTAddress/index.vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {listServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";
import YTCard from "@/components/YTCard/newIndex.vue";
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import {getEnvironmentPhotoIgnore, updateEnvironmentPhotoIgnore} from "@/api/organize/ignoreTenant.js";
const {route} = getRoute()

// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.storeId)
  if (isEdit.value) {
    await getDetail()
  } else {
    ElMessage.error("信息获取失败")
    loading.value = true
  }
})
// 获取商家信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await getBikeStoreIgnore(route.query.storeId)
    console.log("res", res)
    ruleForm.value = res
    ruleForm.value.operatingHours.map(i => {
      i.operatingTime = [moment(moment().format("YYYY-MM-DD") + " " + i.operatingStart).format("YYYY-MM-DD HH:mm:ss"), moment(moment().format("YYYY-MM-DD") + " " + i.operatingEnd).format("YYYY-MM-DD HH:mm:ss")]
    })
    let temp = [ruleForm.value.storeAddress.provinceCode, ruleForm.value.storeAddress.cityCode]
    if (ruleForm.value.storeAddress.districtCode) temp.push(ruleForm.value.storeAddress.districtCode)
    createTenantBikeStoreRef.value.handleReviewAddressCode(temp)
    nextTick(() => {
      createTenantBikeStoreRef.value.handleReviewTagList()
    })
    let tempRecipient = [ruleForm.value.recipientInfo.recipientAddress.provinceCode, ruleForm.value.recipientInfo.recipientAddress.cityCode]
    if (ruleForm.value.recipientInfo.recipientAddress.districtCode) tempRecipient.push(ruleForm.value.recipientInfo.recipientAddress.districtCode)
    createTenantBikeStoreRef.value.handleReviewRecipientAddressCode(tempRecipient)
    createTenantBikeStoreRef.value.handleReviewPic([ruleForm.value.storeLogo])
    createTenantBikeStoreRef.value.handleCoverReviewPic([ruleForm.value.storeCoverImage])
    createTenantBikeStoreRef.value.handlePhotoReviewPic(ruleForm.value.photoList)
    if (ruleForm.value.storeDiscoverCoverImage) createTenantBikeStoreRef.value.handleReviewStoreDiscoverCoverPic([ruleForm.value.storeDiscoverCoverImage])
    console.log("ruleForm.value", ruleForm.value)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  tenantId: null,
  storeId: null,
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  nonSelfOperatedLink: null,
  referralOfficer: {
    name: null,
    phone: null
  },
  certificationType: null,
  partnerStores: [],
  serviceModeTypes: [],
  businessTypes: [],
  summary: null,
  summaryEn: null,
  description: null,
  descriptionEn: null,
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  tagIdList: [],
  assistsOperation: true,
  storeCoverImage: null,
  photoList: [],
  storeDiscoverCoverImage: null
})
// 处理表单提交新建俱乐部
const handleCreateTenantBikeStore = async () => {
  try {
    loading.value = true
    await updateBikeStoreIgnore(ruleForm.value)
    ElMessage.success("修改成功")
    router.push({ path: "/listTenantBikeStore" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 创建商家理疗服务商组件锚点
const createTenantBikeStoreRef = ref()

/*标签页相关*/
// 当前标签页
const currentTab = ref("1")
// 处理标签页改变
const handleTabChange = async (e) => {
  console.log("run in handleTabChange", e)
  if (currentTab.value === "3") {
    await handleGetEnvironmentPhotoList()
  } else if (currentTab.value === "2") {
    await handleSearch()
  }
}

/*车店店员信息相关*/
/*车店店员信息相关*/
// 车店店员信息搜索表单
const formData = reactive({
  keyword: null
})
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      keyword: formData.keyword,
      providerType: "BIKE_STORE",
      tenantId: ruleForm.value.tenantId,
    }
    const res = await listServiceProviderIgnoreTenant(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  handleSearch('btnSearch')
}
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
// 表格数据
const tableData = ref([])
// 表头
const headers = ref([
  { title: '头像', key: 'avatar', nowrap: true },
  { title: '姓名', key: 'name', nowrap: true },
  { title: '手机号', key: 'phone', nowrap: true },
  { title: '技能特点', key: 'tagList', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 新建车店店员
const handleAdd = () => {
  router.push({path: "/addBikeStoreMember", query: {tenantId: ruleForm.value.tenantId, storeId: ruleForm.value.storeId}})
}
// 处理查看车店店员详情
const handleGetTherapyDetail = (item) => {
  router.push({path: "/editBikeStoreMember", query: {tenantId: item.tenantId, providerId: item.providerId}})
}

/*上传图片组件相关*/
// 店铺环境上传组件锚点
const boxUploadRef = ref()
// 店铺环境图
const environmentPhotoList = ref([])
// 处理店铺环境上传成功
const handlePicSuccess = (url) => {
  environmentPhotoList.value = [];
  environmentPhotoList.value = url;
  isEnvironmentPhotoListChange.value = true
  loading.value = false;
};
// 处理店铺环境反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList);
};
// 处理删除店铺环境
const handlePicRemove = (url) => {
  environmentPhotoList.value = url
  isEnvironmentPhotoListChange.value = true
}

/*店铺环境相关*/
// 修改按钮展示状态
const isEnvironmentPhotoListChange = ref(false)
// 处理修改店铺环境
const handleUpdateEnvironmentPhotoList = async () => {
  try {
    loading.value = true
    await updateEnvironmentPhotoIgnore(ruleForm.value.storeId, {environmentPhotoList: environmentPhotoList.value})
    isEnvironmentPhotoListChange.value = false
    ElMessage.success("修改成功")
    handleGetEnvironmentPhotoList()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 获取店铺环境
const handleGetEnvironmentPhotoList = async () => {
  try {
    loading.value = true
    const res = await getEnvironmentPhotoIgnore(ruleForm.value.storeId)
    environmentPhotoList.value = res.environmentPhotoList
    handleReviewPic(environmentPhotoList.value)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

</script>

<template>
  <el-tabs
      v-model="currentTab"
      type="card"
      class="demo-tabs"
      @tab-change="handleTabChange"
  >
    <el-tab-pane label="基本信息" name="1">
    </el-tab-pane>
    <el-tab-pane label="车店店员介绍" name="2">
    </el-tab-pane>
    <el-tab-pane label="店铺环境" name="3">
    </el-tab-pane>
  </el-tabs>
  <div v-loading="loading" v-show="currentTab === '1'" style="height: calc(100% - 55px)">
    <createTenantBikeStore ref="createTenantBikeStoreRef" :is-edit="isEdit" v-model="ruleForm" @success="handleCreateTenantBikeStore"></createTenantBikeStore>
  </div>
  <div v-loading="loading" v-show="currentTab === '2'" style="height: calc(100% - 55px)">
    <div class="therapist_wrapper">
      <div class="flex_bt flex_align_t">
        <div>
          <div class="flex_left mg_b_1">
            <v-btn color="success" @click="handleAdd">
              <template v-slot:default>
                <div class="flex_bt">
                  <img
                      style="width: 14px; height: 14px; margin-right: 4px"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
                  />
                  <span>车店店员</span>
                </div>
              </template>
            </v-btn>
          </div>
          <div class="tips_default">新增同时创建员工账号</div>
        </div>
        <div>
          <div class="flex_left flex_warp flex_align_t">
            <v-text-field
                v-model="formData.keyword"
                placeholder="请输入关键词搜索"
                label="关键词搜索"
                variant="outlined"
                clearable
                style="width: 250px;"

            ></v-text-field>
            <v-btn class="mg_r_1 mg_l_1" color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
            <v-btn size="large" @click="handleReset">重置</v-btn>
          </div>
        </div>
      </div>
      <div style="min-height: calc(100% - 78px)">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.avatar="{ item }">
            <img style="width: 34px;height: 34px;border-radius: 34px;" :src="item.avatar ? item.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'">
          </template>

          <template v-slot:item.tagList="{ item, index }">
            <div v-if="item.tagList.length > 0">
              <div class="flex_left flex_warp" style="gap: 10px;">
                <div class="therapist_card_tag" v-for="(sonItem, sonIndex) in item.tagList" v-show="sonIndex <= 3" :key="`tableData${index}tagList${sonIndex}`">
                  {{sonItem.tagName}}
                </div>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="详情"
                  placement="left">
                <v-icon v-if="ruleForm.assistsOperation" class="cursor-pointer mg_r_1" icon="mdi-list-box-outline" color="warning" @click="handleGetTherapyDetail(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
  <div v-loading="loading" v-show="currentTab === '3'" style="min-height: calc(100% - 55px)">
    <div class="container_box">
      <YTCard :title="`店铺环境`">
        <template #container>
          <div class="mg_b_1">
            <BoxUpload ref="boxUploadRef" :file-size="3" :ali-oss-path="'STORE_ENVIRONMENT_PHOTO_LIST'" @progress="loading = true" @success="handlePicSuccess" @remove="handlePicRemove" :limit="5"/>
          </div>
          <div>
            <v-btn color="primary" v-if="isEnvironmentPhotoListChange" @click="handleUpdateEnvironmentPhotoList">确认修改</v-btn>
          </div>
        </template>
      </YTCard>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.therapist_wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  .therapist_card_tag {
    font-size: 13px;
    background-color: #cbcbcc;
    box-sizing: border-box;
    padding: 0 6px;
    color: #fff;
    border-radius: 8px;
  }
}
</style>
